import React from "react";
import "./sub-data-Inection.css";
import Dataing from "../../image/dataiing.svg";
import DataIngestionHeader from "./DataingestionHeader";
import DataIngestionTitle from "./dataingestionTitle";
import DataIngestionContent from "./dataingestionContent";

function SubDataIngestion() {
  return (
    <div>
      <div className="container">
        <div className="row DataIngestionSearch">
          <div className="col-4">
            <form action="">
              <input type="search" className="searchsty" placeholder="Search" />
            </form>
          </div>
          <div className="col-1"></div>
          <div className="col-4">
            <form action="">
              <input type="search" className="searchsty" placeholder="Search" />
            </form>
          </div>
        </div>
      </div>
      <div className="container DataInjectionSubSection">
        <div className="row">
          {/* start logo section */}
          <div className="col-1">
            <div className="userlogo">
              <img src={Dataing} alt="" className="userlogoicon" />
            </div>
          </div>

          <div className="col-11">
            <div className="DataIngestionComponent">< DataIngestionHeader /></div>
            <div>< DataIngestionTitle /></div>
            <div>< DataIngestionTitle cname="dataingestiontitlecolumnActive" component={<DataIngestionContent />} /></div>
            <div>< DataIngestionTitle cname="dataingestiontitlecolumnActive" /></div>
            <div className="DataIngestionComponent">< DataIngestionTitle cname="dataingestiontitlecolumnActive" /></div>
          </div>
          {/* End logo section */}
        </div>
      </div>
    </div>
  );
}

export default SubDataIngestion;
